import { HelpComponent } from './../components/help/help';
import { GlossaryDefinitionComponent } from './../components/glossary-definition/glossary-definition';
import { AddSignalComponent } from './../components/add-signal/add-signal';
import { AffiliateInfoComponent } from './../components/affiliate-info/affiliate-info';
import { CoinSearchComponent } from './../components/coin-search/coin-search';
import { UserSubscriptionComponent } from './../components/user-subscription/user-subscription';

import { ComponentsModule } from './../components/components.module';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { CoinsProvider } from '../providers/coins/coins';
import { AuthProvider } from '../providers/auth/auth';
import { ToastService } from './../providers/util/toast.service';
import { AlertService } from './../providers/util/alert.service';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

import { UserProvider } from '../providers/user/user';
import { FormsModule } from '@angular/forms';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MarkdownModule } from 'ngx-markdown';

//Native Plugins
import { IonicStorageModule } from '@ionic/storage';
import { GooglePlus } from '@ionic-native/google-plus';

import { InAppBrowser } from '@ionic-native/in-app-browser';

import { BtBackendProvider } from '../providers/bt-backend/bt-backend';
import { AdminProvider } from '../providers/admin/admin';
import { AdminUserComponent } from '../components/admin-user/admin-user';
import { SettingsProvider } from '../providers/settings/settings';
import { WatchlistProvider } from '../providers/watchlist/watchlist';
import { PortfolioProvider } from '../providers/portfolio/portfolio';
import { CccSocketProvider } from '../providers/ccc-socket/ccc-socket';
import { NewsProvider } from '../providers/news/news';
import { UserAppSettingsComponent } from '../components/user-app-settings/user-app-settings';
import { SignalsProvider } from '../providers/signals/signals';

import { ExchangeComponent } from '../components/exchange/exchange';
import { PriceFeedProvider } from '../providers/price-feed/price-feed';
import { PwaProvider } from '../providers/pwa/pwa';
import { GhostProvider } from '../providers/ghost/ghost';
import { HelpProvider } from '../providers/help/help';
import { UserSubscriptionCoinbaseComponent } from '../components/user-subscription-coinbase/user-subscription-coinbase';
import { FirstPromoterProvider } from '../providers/first-promoter/first-promoter';
import { FCM } from '@ionic-native/fcm';
import { FcmProvider } from '../providers/fcm/fcm';
import { IntercomProvider } from '../providers/intercom/intercom';
import { SignalsCalendarComponent } from '../components/signals-calendar/signals-calendar';
import { AddGradeComponent } from '../components/add-grade/add-grade';
import { GradesProvider } from '../providers/grades/grades';
import { PulseProvider } from '../providers/pulse/pulse';
import { ReportsProvider } from '../providers/reports/reports';
import { AddReportComponent } from '../components/add-report/add-report';
import { AddSignalStocksComponent } from '../components/add-signal-stocks/add-signal-stocks';
import { StreamProvider } from '../providers/stream/stream';
import { AddStreamComponent } from '../components/add-stream/add-stream';


//PROD
// export const firebaseConfig = {
//   apiKey: "AIzaSyAtVRO1elGdC5283pK3Xi-4CN345F1l6ro",
//   authDomain: "blocktrade-32c5c.firebaseapp.com",
//   databaseURL: "https://blocktrade-32c5c.firebaseio.com",
//   projectId: "blocktrade-32c5c",
//   storageBucket: "blocktrade-32c5c.appspot.com",
//   messagingSenderId: "469025252700"
// };

//DEV
export const firebaseConfig = {
    apiKey: "AIzaSyCfU4VQ-16UJTsI5VTR1bjS_dxGfuHWcSc",
    authDomain: "blocktistis-dev.firebaseapp.com",
    databaseURL: "https://blocktistis-dev.firebaseio.com",
    projectId: "blocktistis-dev",
    storageBucket: "blocktistis-dev.appspot.com",
    messagingSenderId: "563744137295"
};

@NgModule({
    declarations: [
        MyApp
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp, {
            mode: 'md'
        }),
        MarkdownModule.forRoot(),
        HttpClientModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFirestoreModule,
        ComponentsModule,
        IonicStorageModule.forRoot(),
        BrowserAnimationsModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        CoinSearchComponent,
        AdminUserComponent,
        UserSubscriptionComponent,
        AffiliateInfoComponent,
        UserAppSettingsComponent,
        AddSignalComponent,
        AddSignalStocksComponent,
        AddGradeComponent,
        AddReportComponent,
        AddStreamComponent,
        ExchangeComponent,
        GlossaryDefinitionComponent,
        HelpComponent,
        UserSubscriptionCoinbaseComponent,
        SignalsCalendarComponent
    ],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        AngularFireDatabase,
        AngularFireAuth,
        CoinsProvider,
        AuthProvider,
        AlertService,
        ToastService,
        UserProvider,
        FormsModule,
        BtBackendProvider,
        AdminProvider,
        SettingsProvider,
        WatchlistProvider,
        PortfolioProvider,
        CccSocketProvider,
        NewsProvider,
        InAppBrowser,
        GooglePlus,
        SignalsProvider,
        PriceFeedProvider,
        PwaProvider,
        GhostProvider,
        HelpProvider,
        FirstPromoterProvider,
        FCM,
        FcmProvider,
        IntercomProvider,
        GradesProvider,
        PulseProvider,
        ReportsProvider,
    StreamProvider
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts